import { render, staticRenderFns } from "./JqxDetailsIngressiUscite.vue?vue&type=template&id=3b215dd3&scoped=true"
import script from "./JqxDetailsIngressiUscite.vue?vue&type=script&lang=js"
export * from "./JqxDetailsIngressiUscite.vue?vue&type=script&lang=js"
import style0 from "./JqxDetailsIngressiUscite.vue?vue&type=style&index=0&id=3b215dd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b215dd3",
  null
  
)

export default component.exports